import * as moment from 'moment';

import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/constants/api';


export default class ReceivedPaymentTableSchema {
	keyColumn: string = 'uuid';
	userInfo: any = (window as any).userInfo;
	serverUrl: string = `${Api.invoice.received_payments}`;
	containerContext: any;
	headers: Array<object> = [
		{ "label": "#", "thClass": "th-number" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
		// { "label": $localize`:@@ts.project_name:Project Name`, "thClass": "th-project" },
		{ "label": $localize`:@@ts.amount_received:Amount Received`, "thClass": "th-amount" },
		{ "label": $localize`:@@ts.type:Type`, "thClass": "th-type" },
		{ "label": $localize`:@@ts.status:Status`, "thClass": "th-payment" },
		{ "label": $localize`:@@ts.payment_ref_id:Payment Ref/ID`, "thClass": "th-bayanPay" },
		{ "label": "", "thClass": "th-record" },
		{ "label": "", "thClass": "th-more-client", "hidden": true }
	];
	cols: Array<object> = [
		{ "key": "invoice_number", "tdClass": "td-number" },
		{
			"key": "date", "tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (`
						<div class="date">
							<span class="day">${d.format('DD')}</span>
							<span class="month">${d.format('MMM')}</span>
							<span class="year">${d.format('YYYY')}</span>
						</div>`
					);
				}

				return '';
			}
		},
		{
			"key": "client_name", "tdClass": "td-client-name",
			// "render": (value) => `<span class="name-alpha">${getAcronym(value)}</span>${value}`
		},
		// {
		// 	"key": "invoice_title", "tdClass": "td-project-name",
		// 	"render": (value) => {
		// 		return value ? value : 'Unknown Title'
		// 	}
		// },
		{
			"key": "amount",
			"tdClass": "td-amount",
			"render": (value, row) => {
				let currency = row.currency ? row.currency : this.userInfo?.currency_symbol;
				return `<div class="amount">
                            <span class="price">${value ? value : 0}</span>
                            <span class="sar">${currency}</span>
                        </div>`
				//return this.containerContext.currencyPipe.transform(value ? value : 0)
			}
		},
		{ "key": "payment_type", "tdClass": "td-type", "render": (value) => `${value}` },
		{
			"key": "status", "tdClass": "td-payment",
			"render": (value, row) => {
				let status = i18n[value] ? i18n[value] : value;
				let colorClass = 'font-weight-bold';
				if(row.is_expired && row.payment_refer_number && row.status != 'successful') {
					colorClass = 'status-tag highlight';
					return `<span class="${colorClass}" >Expired</span>`;
				} else if (value == 'successful') {
					colorClass = 'status-tag success';
				} else if (value == 'pending') {
					colorClass = 'status-tag warning';
				} else if (value == 'unsuccessful') {
					colorClass = 'status-tag highlight';
				}

				return `<span class="${colorClass}" >${status}</span>`;
			}
		},
		{
			"key": "payment_refer_number", "tdClass": "td-bayanPay font-weight-bold text-truncate",
			"render": (value) => {
				let t = value ? value : i18n.na;
				return `<span title="${t}">${t}</span>`;
			}
		},
		{
			"key": "status",
			"tdClass": "td-record",
			"render": (value, row) => {
				let btn = '';
				if(row.is_expired && row.payment_refer_number && row.status != 'successful') {
					btn = `<a href="javascript:void(0);" class="delete">
								<svg class="delete-payment-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
									<g fill="none" fill-rule="evenodd">
										<g fill="#FB4575">
											<path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
										</g>
									</g>
								</svg>
							</a>
							<a href="javascript:void(0);" class="resend-payment">Resend</a>`
				}
				if(row.payment_refer_number && row.status != 'successful') {
					btn = btn + `<a href="javascript:void(0);" class="copy-to-clipboard">
						Copy
					</a>`
				}

				return btn
			},
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('copy-to-clipboard')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.COPY_CLIPBOARD, row);
				}
				if (e.target.classList.contains('resend-payment')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.RESEND_PAYMENT, row);
				}
				if (e.target.classList.contains('delete') || e.target.classList.contains('delete-payment-btn')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.DELETE_PAYMENT, row);
				}
			}
		},
		{ "key": "", "tdClass": "td-more-client" }
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}
